// src/modules/LiberacoesFinanceiras/index.jsx
import React, { useState, useEffect } from 'react';
import { MainContainer } from '../../components/template/MainContainer';
import PaymentTable from './PaymentTable';
import Preloader from '../../components/template/Preloader';
import { fetchPayments } from './services/paymentService';

export default () => {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadPayments = async () => {
      try {
        setLoading(true);
        const data = await fetchPayments();
        setPayments(data);
        setError(null);
      } catch (err) {
        setError('Error loading payments.');
        console.error('Error loading payments:', err);
        window.showAlert('danger', 'Error loading payments. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    loadPayments();
  }, []);

  const handlePaymentsProcessed = () => {
    // Reload payments after processing
    setLoading(true);
    fetchPayments()
      .then(data => {
        setPayments(data);
        setError(null);
      })
      .catch(err => {
        setError('Error reloading payments.');
        console.error('Error reloading payments:', err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  if (loading) return <Preloader />;

  if (error) {
    return (
      <MainContainer headerData={{ title: `Liberações Financeiras`, subtitle: `Autorização de Pagamento DDA` }}>
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
        <button className="btn btn-primary" onClick={() => window.location.reload()}>
          Retry
        </button>
      </MainContainer>
    );
  }

  return (
    <MainContainer headerData={{ title: `Liberações Financeiras`, subtitle: `Autorização de Pagamento DDA` }}>
      <PaymentTable payments={payments} onPaymentsProcessed={handlePaymentsProcessed} />
    </MainContainer>
  );
};
